import { ReactNode } from "react"

type CustomChangeItemProps = {
   className?: string
   children?: ReactNode
}

const CustomChangeItem = ({ className, children }: CustomChangeItemProps) => {
   return <span className={className}>{children}</span>
}

export default CustomChangeItem
